import React, { useState, useEffect } from 'react';
import './App.css';
import './Mint.css';
import { visualEffects } from './tools/effects';
import { useMediaQuery } from 'react-responsive';
import { CoinbaseConnector, contract, blockchain, provider, abi, jesseContract, formatNumber } from './tools/utils';
import { MdToggleOn, MdCancel } from "react-icons/md";
import { ethers } from 'ethers';
import { useAccount, usePublicClient, useWalletClient } from 'wagmi';
import { createPublicClient, createWalletClient, custom, http } from 'viem';
import { base } from 'viem/chains';
// import Partner from "./partner";


// Media Screen Resolution
const Desktop = ({ children }) => {
  const isDesktop = useMediaQuery({ minWidth: 769 });
  return isDesktop ? children : null;
};

const Mobile = ({ children }) => {
  const isMobile = useMediaQuery({ maxWidth: 768 });
  return isMobile ? children : null;
};

// Global Variables
let account, publicClient, walletClient;
/**
 * Mint is a component that shows the mint page
 * @param {function} setComponent - a function to set the component
 * @returns {JSX.Element} - the mint page component
 */
const Mint = ({setComponent}) => {
  account = useAccount();
  const { data: readClient} = usePublicClient();
  const { data: writeClient } = useWalletClient(); 

  const [eligibleMints, setEligibleMints] = useState({total: null, air3: null, air2: null, air1: null, air5: null, air4: null, air6: null});
  const [minted, setMinted] = useState({total: null, air3: null, air2: null, air1: null, air5: null, air4: null, air6: null});
  const [mintLimits, setMintLimits] = useState({air3: null, air2: null, air1: null, air5: null, air4: null, air6: null});
  const [loading, setLoading] = useState(false);
  const [transactionResult, setTransactionResult] = useState(null);
  const [txError, setTxError] = useState(null);
  const [mintLog, setMintLog] = useState();
  const [mintLogged, setMintLogged] = useState(null);
  const [errorMessage, setErrorMessage] = useState("");
  const [errorMessageVisible, setErrorMessageVisible] = useState(false);
  const [hideNotifications, setHideNotifications] = useState(true);
  const [condition, setCondition] = useState(false);
  const [accountBal, setAccountBal] = useState(null);
  const [tokenBal, setTokenBal] = useState(null);
  const [requiredAmount, setRequiredAmount] = useState(null);
  const [isApproving, setIsApproving] = useState(false);
  const [isMinting, setIsMinting] = useState(false);

  const fetchETHbalance = async () => {
        let call1 = await provider.getBalance(account.address);    
        const tx = ethers.formatEther(call1?.toString());
        setAccountBal(Number(tx).toFixed(10));   
  }

  const fetchTokenBalance = async () => {
    let tx1 = await jesseContract.balanceOf(account.address);
    let balance = ethers.formatEther(tx1);
    setTokenBal(Number(balance).toFixed(0));
  }
  
  const handleMint = async () => {
    if (loading) return;
    try {
      publicClient = createPublicClient({
        chain: base,
        transport: http(),
      })
    
      walletClient = createWalletClient({
        account: account.address, 
        chain: base, 
        transport: custom(writeClient.transport)
      });
    
      setLoading(true);

      if (condition) {

        //viem        
        const txHash = await walletClient.writeContract({
          address: blockchain.address,          // cybernaut contract
          abi: abi.cybernaut,
          functionName: "mint",
          args: []
        });

        const receipt = await publicClient.waitForTransactionReceipt({ hash: txHash });

        if (receipt.status !== 'success') {
            // console.log("Mint transaction reverted");
            setTxError("Mint reverted.");
            setLoading(false);
            return;
        } else { 
            setTransactionResult(txHash);
            setLoading(false);
            return;
        }

      } else {  
      
        const fee = await contract.cyberFee();
        const mintfee = Number(ethers.formatEther(fee?.toString()));
        // check if user can mint a CYBERNAUT NFT
        if (tokenBal < mintfee) {
          setErrorMessage("Insufficient Funds to Mint.");
          setErrorMessageVisible(true);
          setLoading(false);
          return;
        }

        // check for token approval 
        let txA = await jesseContract.allowance(account.address, blockchain.address);
        const token = ethers.formatEther(txA);
        const tokenApproval = Number(token);

        // if unapproved, insert approval call first
        if (tokenApproval < mintfee) {
          
          const txHash = await walletClient.writeContract({
            address: blockchain.jesse_contract_address,          // cybernaut contract
            abi: abi.jesse,
            functionName: "approve",
            args: [blockchain.address, tokenBal]
          });

          const receipt = await publicClient.waitForTransactionReceipt({ hash: txHash });

          if (receipt.status !== 'success') {
              // console.log("Approval denied");
              setTxError("Approval denied.");
              setLoading(false);
              return;
          }  

        } else {

          //viem        
          const txHash = await walletClient.writeContract({
            address: blockchain.address,          // cybernaut contract
            abi: abi.cybernaut,
            functionName: "mint",
            args: []
          });

          const receipt = await publicClient.waitForTransactionReceipt({ hash: txHash });

          if (receipt.status !== 'success') {
              // console.log("Mint transaction reverted");
              setTxError("Mint reverted.");
              setLoading(false);
              return;
          } else { 
              setTransactionResult(txHash);
              setLoading(false);
              fetchETHbalance();
              fetchTokenBalance();
              return;
          }
        }
      }
  
      } catch (err) {      
        setLoading(false);
        setErrorMessage("Failed to mint.");
        setErrorMessageVisible(true);
      }  
  };

  const addressMatch = async(_tokenId) => {
    const ownerData = await contract.ownerOf(_tokenId);
    if (account.address.toLowerCase() === ownerData.toLowerCase()) {
      setMintLogged(_tokenId);
      if (hideNotifications === false) {
        setHideNotifications(true);
        setTimeout(() => {setHideNotifications(false)}, 6000);
      }
    }
  }
  
  const mintListener = () => {
    contract.once("proofOfCybernaut", (tokenId, event) => {
      let mintdata = {
        tokenId: tokenId.toString(), 
        timestamp: Date.now(), 
        event
      };
      setMintLog(mintdata);  
      addressMatch(tokenId);
    });
  }

  // Create the target date in a way that works across all browsers
  const targetDate = new Date();
  targetDate.setFullYear(2025, 3, 12); // April 12, 2025 (months are 0-indexed)
  targetDate.setHours(19, 0, 0, 0); // 20:00:00 UTC+1
  // Adjust for UTC+1 timezone (1 hour ahead of UTC)
  targetDate.setHours(targetDate.getHours() + 1);
  const countDownDate = targetDate.getTime();

  const [countDown, setCountDown] = useState(
    Math.max(0, Math.floor((countDownDate - Date.now()) / 1000))
  );

  useEffect(() => {
    const interval = setInterval(() => {
      const secondsRemaining = Math.floor((countDownDate - Date.now()) / 1000);
      
      if (secondsRemaining >= 0) {
        setCountDown(secondsRemaining);
      } else {
        setCountDown(0);
        clearInterval(interval);
      }
    }, 1000);
    
    return () => clearInterval(interval);
  }, [countDownDate]);

  // Calculate time units
  const days = Math.floor(countDown / (60 * 60 * 24));
  const hours = Math.floor((countDown % (60 * 60 * 24)) / (60 * 60));
  const minutes = Math.floor((countDown % (60 * 60)) / 60);
  const seconds = Math.floor(countDown % 60);
let isLimits;
  useEffect(() => {
    if (account || transactionResult || txError || mintLog) {
      if (isLimits) return;
      isLimits = true;
      const fetchHistory = async () => {
        try {
          // Fetch all data first        
        const read1 = await contract.air3Limit();
        const read2 = await contract.air2Limit();
        const read3 = await contract.air5Limit();
        const read4 = await contract.air1Limit();
        const read5 = await contract.air4Limit();
        const read6 = await contract.air6Limit();
        const air3Limit = Number(read1);
        const air2Limit = Number(read2);
        const air5Limit = Number(read3);
        const air1Limit = Number(read4);
        const air4Limit = Number(read5);
        const air6Limit = Number(read6);      
        const hist = await contract.cybernautminted(account.address);
        const nohist = await contract.whitelisted(account.address);

        if (!requiredAmount) {
          let tx2 = await contract.cyberFee(); 
          const fee = ethers.formatEther(tx2?.toString());
          const cyberFee = Number(fee);
          setRequiredAmount(formatNumber(cyberFee.toFixed(0)));
        }
        
        setMintLimits({air1: air1Limit, air2: air2Limit, air5: air5Limit, air3: air3Limit, air4: air4Limit, air6: air6Limit});
      
          // Convert all values to numbers
          const [
            totalHistory, // numeric value retrieved
            history1, history2, history3, 
            history4, history5, history6
          ] = hist.map(Number);
      
          const [
            zeroHistory, // boolean value retrieved
            noHistory1, noHistory2, noHistory3,
            noHistory4, noHistory5, noHistory6
          ] = [
            nohist[0],  
            Number(nohist[1]), Number(nohist[2]),
            Number(nohist[3]), Number(nohist[4]),
            Number(nohist[5]), Number(nohist[6])
          ];
      
          // Calculate condition using FRESH values (not state)
          let hasAvailableMints;
          if (zeroHistory && totalHistory > 0) {
            hasAvailableMints = (
              // case for history found
              (history1 > 0 && air3Limit > 0) ||
              (history2 > 0 && air2Limit > 0) ||
              (history3 > 0 && air1Limit > 0) ||
              (history4 > 0 && air5Limit > 0) ||
              (history5 > 0 && air4Limit > 0) ||
              (history6 > 0 && air6Limit > 0)          
            );
            
          } else if (zeroHistory && totalHistory < 1) {
            hasAvailableMints = (
              // case for no history found
              ((noHistory1 - history1) > 0 && air3Limit > 0) ||
              ((noHistory2 - history2) > 0 && air2Limit > 0) ||
              ((noHistory3 - history3) > 0 && air1Limit > 0) ||
              ((noHistory4 - history4) > 0 && air5Limit > 0) ||
              ((noHistory5 - history5) > 0 && air4Limit > 0) ||
              ((noHistory6 - history6) > 0 && air6Limit > 0)          
            );
          } else hasAvailableMints = false;
      
          // Update all state at once
          setEligibleMints({
            total: totalHistory > 0 ? (history1 + history2 + history3 + history4 + history5 + history6) : 
             (noHistory1 + noHistory2 + noHistory3 + noHistory4 + noHistory5 + noHistory6),

            air3: totalHistory > 0 ? history1 : noHistory1,
            air2: totalHistory > 0 ? history2 : noHistory2,
            air1: totalHistory > 0 ? history3 : noHistory3,
            air5: totalHistory > 0 ? history4 : noHistory4,
            air4: totalHistory > 0 ? history5 : noHistory5,
            air6: totalHistory > 0 ? history6 : noHistory6
          });
      
          setMinted({
            total: totalHistory,
            air3: totalHistory > 0 ? (noHistory1 - history1) : 0,
            air2: totalHistory > 0 ? (noHistory2 - history2) : 0,
            air1: totalHistory > 0 ? (noHistory3 - history3) : 0,
            air5: totalHistory > 0 ? (noHistory4 - history4) : 0,
            air4: totalHistory > 0 ? (noHistory5 - history5) : 0,
            air6: totalHistory > 0 ? (noHistory6 - history6) : 0,
          });
      
          setCondition(hasAvailableMints);
      
        } catch (error) {
          console.error('Error in fetchHistory:', error);
          setErrorMessage("Failed to load mint data");
          setErrorMessageVisible(true);
        }
      };
     
      fetchHistory();
      isLimits = false;
    }
  }, [account, transactionResult, txError, mintLog]);

  let isListening;
  useEffect(() => {
    if (isListening) return;
    isListening = true;
    mintListener();
    isListening = false;
  }, [mintLog]);

  let isFetching;

  useEffect(() => {
    if (account.isConnected & !accountBal) {
      if (isFetching) return;
      isFetching = true;
      fetchETHbalance();  
      fetchTokenBalance();    
      isFetching = false;
    }
  },[account])

  return (
    <div className='mint-container'>
      {account ? (
        <>
        <Desktop>
          <div className="mintOutlay">
            <div className='mintChecker'>
                <div className='air1 mintbox'>
                  <img src={visualEffects.air1} className="icon" />
                  <br />
                  <span className='mintText'>Air1 x {eligibleMints.air1}</span>
                  <br />                
                  <span className='mintedText pink'>{minted.air1} / {mintLimits.air1} minted</span>
                </div>
                <div className="air2 mintbox">
                  <img src={visualEffects.air2} className="icon" />
                  <br />
                  <span className='mintText'>Air2 x {eligibleMints.air2}</span>
                  <br />                
                  <span className='mintedText pink'>{minted.air2} / {mintLimits.air2} minted</span>
                </div>
                <div className="air3 mintbox">
                  <img src={visualEffects.air3} className="icon" />
                  <br />
                  <span className='mintText'>Air3 x {eligibleMints.air3}</span>
                  <br />                
                  <span className='mintedText pink'>{minted.air3} / {mintLimits.air3} minted</span>
                </div>
                <div className="air4 mintbox">
                  <img src={visualEffects.air4} className="icon" />
                  <br />
                  <span className='mintText'>Air4 x {eligibleMints.air4}</span>
                  <br />                
                  <span className='mintedText pink'>{minted.air4} / {mintLimits.air4} minted</span>
                </div>
                <div className="air5 mintbox">
                  <img src={visualEffects.air5} className="icon" />
                  <br />
                  <span className='mintText'>Air5 x {eligibleMints.air5}</span>
                  <br />                
                  <span className='mintedText pink'>{minted.air5} / {mintLimits.air5} minted</span>
                </div>
                <div className="air6 mintbox">
                  <img src={visualEffects.air6} className="icon" />
                  <br />
                  <span className='mintText'>Air6 x {eligibleMints.air6}</span>
                  <br />                
                  <span className='mintedText pink'>{minted.air6} / {mintLimits.air6} minted</span>
                </div>
              <div>
              </div>
            </div>
            <div className="rewardsText"> You are eligible to mint </div>
            {condition ? <div className="countText">{eligibleMints.total}</div> : <div className="countText">0</div>}
            <div className="rewardsTextSmall">CYBERNAUT NFTs</div>
            {condition ? 
              <div className="rewardsTextSmall pink">All Whitelisted mints are free.</div>
              :
              <div className="rewardsTextSmall sunfire">Mint a CYBERNAUT NFT for <span className="countText countTextShrink">{requiredAmount}</span> JESSE.</div>
            }
              <div className="mintpanel">    
                {countDown <= 0 ? 
                <button className="mint-button" onClick={handleMint} disabled={loading} style={loading ? { opacity: 0.5, cursor: 'not-allowed' } : {cursor: 'pointer'}}>
                  <span className='smaller'>{condition ? 'free' : 'paid'}</span>{loading ? "Minting..." : " Mint"}
                </button>    
                : 
                <button className="mint-button" onClick={() => {setComponent("home")}} style={{cursor: 'pointer'}}>
                  Exit
                </button>        
            }
            </div>   
          </div>
        </Desktop>
        <Mobile>
          <div className="mobileOutlay">
            <div className='mobileChecker'>
                <div className='air1 mobileMintbox' align="center">
                  <img src={visualEffects.air1} className="icon" />
                </div>
                <div className='mobileMintText'>Air1 x {eligibleMints.air1}</div>
                <div className='mobileMintedText pink'>{minted.air1} / {mintLimits.air1} minted</div>
            </div>
            <div className='mobileChecker'>
              <div className='air2 mobileMintbox' align="center">
                <img src={visualEffects.air2} className="icon" />
              </div>
              <div className='mobileMintText'>Air2 x {eligibleMints.air2}</div>
              <div className='mobileMintedText pink'>{minted.air2} / {mintLimits.air2} minted</div>
            </div>
          </div>
          <div className='mobileChecker'>
            <div className='air3 mobileMintbox' align="center">
              <img src={visualEffects.air3} className="icon" />
            </div>
            <div className='mobileMintText'>Air3 x {eligibleMints.air3}</div>
            <div className='mobileMintedText pink'>{minted.air3} / {mintLimits.air3} minted</div>
          </div>
          <div className='mobileChecker'>
            <div className='air4 mobileMintbox' align="center">
              <img src={visualEffects.air4} className="icon" />
            </div>
            <div className='mobileMintText'>Air4 x {eligibleMints.air4}</div>
            <div className='mobileMintedText pink'>{minted.air4} / {mintLimits.air4} minted</div>
          </div>
          <div className='mobileChecker'>
            <div className='air5 mobileMintbox' align="center">
              <img src={visualEffects.air5} className="icon" />
            </div>
            <div className='mobileMintText'>Air5 x {eligibleMints.air5}</div>
            <div className='mobileMintedText pink'>{minted.air5} / {mintLimits.air5} minted</div>
          </div>
          <div className='mobileChecker'>
            <div className='air6 mobileMintbox' align="center">
              <img src={visualEffects.air6} className="icon" />
            </div>
            <div className='mobileMintText'>Air6 x {eligibleMints.air6}</div>
            <div className='mobileMintedText pink'>{minted.air6} / {mintLimits.air6} minted</div>
          </div>
          
          <div className="minipanel">
            <>
              {condition ? 
              <>
              <div className="rewardsText"> You can mint </div> 
                {condition ? <div className="countText">{eligibleMints.total}</div> : <div className="countText">0</div>}
                <div className="rewardsTextSmall">NFTs for free</div>
              </>
              : 
              <>
              <div className="rewardsText"> Mint</div>
              <div className="countText">1</div>
              <div className="rewardsTextSmall sunfire"> NFT for <span className="countText countTextTiny" style={{fontSize: 'medium'}}>{requiredAmount}</span> JESSE.</div>
              </>
              }
            </>  
            <div>    
                {countDown <= 0 ? 
                <button className="mint-button" onClick={handleMint} disabled={loading} style={loading ? { opacity: 0.5, cursor: 'not-allowed' } : {cursor: 'pointer'}}>
                  <span className='smaller'>{condition ? 'free' : 'paid'}</span>
                  {loading ? "Minting..." : " Mint"}
                </button>
                : 
                <button className="mint-button" onClick={() => setComponent("home")} style={{cursor: 'pointer'}}>
                  Logout
                </button> 
              }
            </div>        
          </div>
        </Mobile>
        </>
      ) : (
        <>
        <div className='mintTitle' align="center">
          <span style={{fontFamily: "NexaHeavy", color: 'skyblue'}}>CyberZero says...</span>
          {countDown > 0 ? "Mint Not yet live!" : "Mint is live!"}

          <div style={{padding: '1vh'}}>
          <CoinbaseConnector />
          </div>
        </div>
        <Desktop>
          <h1 className='waveanimator quote mintboard'>
            {countDown > 0 ? 
              `${days.toString().padStart(2, '0')}:
              ${hours.toString().padStart(2, '0')}:
              ${minutes.toString().padStart(2, '0')}:
              ${seconds.toString().padStart(2, '0')}` 
              : "00:00:00:00"}
          </h1>
        </Desktop>
        <Mobile>
          <h1 className='waveanimator quote mintboardMobile'>
            {countDown > 0 ? 
              `${days.toString().padStart(2, '0')}:
              ${hours.toString().padStart(2, '0')}:
              ${minutes.toString().padStart(2, '0')}:
              ${seconds.toString().padStart(2, '0')}` 
              : "00:00:00:00"}
          </h1>
        </Mobile>
        <div className="tagline">only available <br/>on Base </div>
        <img src={visualEffects.logobase} className="tagImage"/>
        </>
      )}

      
        <div className={"notifications"} style={{display: hideNotifications ? 'block' : 'none'}}>
          {mintLog && (
            <>
            <div className="notify notifyText"> 
              <img className="notifyImg wheat" src={require("./assets/images/alpha.webp")} alt="Mint"/>
              CYBERNAUT <span style={{color:'lime'}}>#{mintLog.tokenId}</span> just minted           
            <MdToggleOn onClick={() => setHideNotifications(!hideNotifications)} style={{cursor: 'pointer', margin: '0vh 1vh'}}/>
            </div>  
            </>          
          )}
          {mintLogged && (
            <>
            <div className="myNotify myNotifyText">
              <img className="myNotifyImg pink" src={(`https://cybernauts.fun/ipfsCache/${mintLogged}.webp`)} alt="Mint"/>
             CYBERNAUT <span style={{color:'maroon'}}>#{mintLogged}</span> minted by you!
            <MdToggleOn onClick={() => setMintLogged(null)} style={{cursor: 'pointer', margin: '0vh 1vh'}}/>
            </div>
            </>
          )}
          {errorMessageVisible && (
            <div className="notify notifyText">              
              <MdCancel /> {errorMessage}
              <MdToggleOn onClick={() => setErrorMessageVisible(false)} style={{cursor: 'pointer', margin: '0vh 1vh'}}/>
            </div>
          )}
          {/* <Partner /> */}
        </div>  
      </div>
  );
};

export default Mint;